import { render, staticRenderFns } from "./goutfclpass.vue?vue&type=template&id=527c21dc&scoped=true&"
import script from "./goutfclpass.vue?vue&type=script&lang=js&"
export * from "./goutfclpass.vue?vue&type=script&lang=js&"
import style0 from "./goutfclpass.vue?vue&type=style&index=0&id=527c21dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c21dc",
  null
  
)

export default component.exports